/* mjade-cart-drawer — 서랍 합계·선택 (2026-09-18 v3 · 대표님 «2안» 확정)
 *
 * 하는 일
 *   ① 상품마다 «선택» 체크를 두고, 체크된 것만 합계에 센다
 *   ② 금액은 /cart.js 의 실제 값을 쓴다 (글자 파싱 안 한다)
 *   ③ 2안 위계 — 합계 라벨을 «TOTAL» 로 바꾸고 차례를 [라벨][선택수][금액] 으로 만든다
 *   ④ 합계 아래 안내문을 문장 단위로 갈라 3단으로 만든다
 *
 * ★ 금액은 «.00 까지» 쓴다 (대표님 2026-09-18). $288.15 / $339.00
 * ★ v1 결함 — 센트를 attribute 에 넣고 다시 파싱해 100 을 두 번 곱했다($518.00 -> $51,800).
 *   그래서 글자 파싱을 아예 버렸다.
 * ★ 차례가 [라벨][금액][선택수] 이면 금액이 «가운데» 뜬다 [실측]. 선택수를 금액 앞에 꽂는다.
 * ★ 루프 방지 — 장바구니가 실제로 달라졌을 때만 다시 받아 온다(merge-cache 서명 비교).
 */
(function () {
  "use strict";
  if (window.__mjCartSel) return;
  window.__mjCartSel = true;

  var LABEL = 'Total';          /* 실제로 보여 주는 값이 «할인까지 반영된 청구액» 이라 Total 이 맞다 */
  var CART = null, lastSig = "", fetching = false, queued = false, PRE = null, POST = "";

  function small() {
    /* ★ 2026-09-18 대표님 — 「모바일 정본으로 두고 PC 도 비슷하게」.
       전에는 모바일에서만 돌아서 PC 에는 체크박스·TOTAL·3단 안내문이 없었다.
       이제 폭과 무관하게 돈다. 이름은 그대로 둔다(부르는 자리가 여러 곳이다). */
    return true;
  }
  function items() {
    return [].slice.call(document.querySelectorAll('cart-drawer .cart-item'));
  }
  function sig() {
    var a = [].slice.call(document.querySelectorAll('cart-drawer [data-merge-cache]'))
      .map(function (e) { return e.getAttribute('data-merge-cache'); });
    return a.join('~') + '|' + items().length;
  }
  function keyOf(row) {
    var a = row.querySelector('.cart-item__remove');
    var h = a ? (a.getAttribute('href') || '') : '';
    var m = h.match(/[?&]id=([^&]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }
  /* 통화 표기는 테마가 쓴 글자에서 «한 번» 배운다. 숫자는 안 읽는다. */
  function learn(el) {
    if (PRE !== null || !el) return;
    var m = String(el.textContent || '').trim().match(/^([^0-9]*)[0-9.,\s]*([^0-9]*)$/);
    if (m) { PRE = m[1] || '$'; POST = m[2] || ''; }
  }
  function money(c) {
    if (PRE === null) PRE = '$';
    /* .00 까지 쓴다 — 숫자 폭이 고르면 세로로 더 잘 맞는다 (대표님 2026-09-18) */
    return PRE + (c / 100).toLocaleString('en-US', {
      minimumFractionDigits: 2, maximumFractionDigits: 2
    }) + POST;
  }
  function put(el, s) {
    if (el && el.textContent.trim() !== s) el.textContent = s;
  }

  /* ③ 합계 줄 — 라벨을 우리 것으로 감싸고 차례를 못박는다 */
  function labelize(sub) {
    var lab = sub.querySelector('.mjc-lab');
    if (!lab) {
      /* 테마가 쓴 «Subtotal:» 글자 마디를 찾아 우리 요소로 바꾼다 */
      for (var i = 0; i < sub.childNodes.length; i++) {
        var n = sub.childNodes[i];
        if (n.nodeType !== 3) continue;
        if (!(n.nodeValue || '').trim()) continue;
        lab = document.createElement('i');
        lab.className = 'mjc-lab';
        lab.textContent = LABEL;
        sub.replaceChild(lab, n);
        break;
      }
      if (!lab) {
        lab = document.createElement('i');
        lab.className = 'mjc-lab';
        lab.textContent = LABEL;
        sub.insertBefore(lab, sub.firstChild);
      }
    }
    put(lab, LABEL);
    return lab;
  }

  /* ④ 안내문 — 문장 단위로 갈라 3단으로. 한 번만 하고 표시를 남긴다. */
  function policies() {
    var box = document.querySelector('cart-drawer .cart-drawer__footer .cart-policies');
    if (!box || box.getAttribute('data-mj-tidy') === '1') return;
    var main = null, divs = box.children;
    for (var i = 0; i < divs.length; i++) {
      if (divs[i].classList && divs[i].classList.contains('mj-applepay-note')) continue;
      main = divs[i]; break;
    }
    if (!main) return;
    var lead = main.querySelector('span');
    var leadTx = lead ? (lead.textContent || '').trim() : '';
    var whole = (main.textContent || '').trim();
    var rest = leadTx ? whole.replace(leadTx, '').trim() : whole;
    /* «마침표 + 공백» 에서만 자른다. $29.99 처럼 마침표 뒤에 공백이 없는 곳은 안 잘린다. */
    var parts = rest.split('. ').map(function (s) { return s.trim(); })
                    .filter(function (s) { return !!s; })
                    .map(function (s) { return /[.!?)]$/.test(s) ? s : s + '.'; })
                    /* 대표님 2026-09-18 — 「예상치 못한 추가금 없습니다」 문장은 서랍에서 뺀다.
                       원본 글자는 sections/cart-drawer.liquid 에 그대로 두고 그릴 때만 거른다. */
                    .filter(function (s) { return !/no surprise charges/i.test(s); });
    while (main.firstChild) main.removeChild(main.firstChild);
    if (leadTx) {
      var b = document.createElement('span');
      b.textContent = leadTx;
      main.appendChild(b);
    }
    for (var k = 0; k < parts.length; k++) {
      var em = document.createElement('em');
      em.textContent = parts[k];
      main.appendChild(em);
    }
    box.setAttribute('data-mj-tidy', '1');
  }

  function paint() {
    if (!small() || !CART) return;
    var rows = items();
    if (!rows.length) return;

    for (var i = 0; i < rows.length; i++) {
      if (rows[i].querySelector('.mjc-chk')) continue;
      var c = document.createElement('input');
      c.type = 'checkbox';
      c.className = 'mjc-chk';
      c.checked = true;
      c.setAttribute('aria-label', 'Include this item in the total');
      c.addEventListener('change', paint);
      rows[i].appendChild(c);
    }

    var on = 0, sum = 0;
    for (var k = 0; k < rows.length; k++) {
      var key = keyOf(rows[k]);
      var it = null;
      for (var j = 0; j < CART.items.length; j++)
        if (CART.items[j].key === key) { it = CART.items[j]; break; }
      var pe = rows[k].querySelector('.cart-item__selling-price') ||
               rows[k].querySelector('.cart-item__price .theme-money');
      learn(pe);
      if (it && pe) put(pe, money(it.final_line_price));
      var chk = rows[k].querySelector('.mjc-chk');
      if (chk && chk.checked) { on++; if (it) sum += it.final_line_price; }
    }

    var sub = document.querySelector('cart-drawer .cart-drawer__footer .subtotal');
    if (!sub) return;
    var mny = sub.querySelector('.theme-money');
    learn(mny);
    labelize(sub);

    var cnt = sub.querySelector('.mjc-cnt');
    if (!cnt) {
      cnt = document.createElement('i');
      cnt.className = 'mjc-cnt';
      if (mny) sub.insertBefore(cnt, mny); else sub.appendChild(cnt);
    } else if (mny && (cnt.compareDocumentPosition(mny) & Node.DOCUMENT_POSITION_PRECEDING)) {
      sub.insertBefore(cnt, mny);   /* 테마가 다시 그려 차례가 어긋났으면 되돌린다 */
    }
    put(cnt, 'Selected ' + on + ' / ' + rows.length);

    /* ★ 2026-09-18 대표님 — 「체크 해제하면 그 상태로 할인 적용된 값이 나오게」.
       [실측] 이 장바구니의 할인은 «장바구니 단위 15% 코드» 이고 줄별 배분은 비어 있다.
       쇼피파이는 장바구니 단위 할인을 줄 소계에 «비례해» 배분한다. 그 방식을 그대로 쓴다.
         고른소계 - (장바구니할인 × 고른소계 / 전체소계)
       전부 고르면 이 식이 total_price 와 같아지지만, 그때는 실제 값을 그대로 써서
       결제창과 한 푼도 안 어긋나게 한다. */
    var allSum = 0;
    for (var q = 0; q < CART.items.length; q++) allSum += CART.items[q].final_line_price;
    var cartDisc = Math.max(0, allSum - CART.total_price);
    var share = (allSum > 0) ? Math.round(cartDisc * sum / allSum) : 0;
    var total = (on === rows.length) ? CART.total_price : (sum - share);
    if (mny) put(mny, money(total));

    /* 할인 줄도 같이 맞춘다 — 합계만 바뀌고 할인 표시가 그대로면 셈이 안 맞아 보인다 */
    var damt = document.querySelector(
      'cart-drawer .cart-drawer__footer .cart-discount__amount');
    if (damt && cartDisc > 0) {
      if (!damt.hasAttribute('data-mj-orig')) {
        damt.setAttribute('data-mj-orig', damt.textContent.trim());
      }
      if (on === rows.length) {
        put(damt, damt.getAttribute('data-mj-orig'));
      } else {
        put(damt, '-' + money(share));
      }
    }

    policies();
  }

  function pull() {
    if (fetching) return;
    fetching = true;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) { CART = c; fetching = false; paint(); })
      .catch(function () { fetching = false; });
  }
  function tick() {
    if (!small()) return;
    var s = sig();
    if (s !== lastSig) { lastSig = s; pull(); }
    else paint();
  }
  function queue() {
    if (queued) return;
    queued = true;
    setTimeout(function () { queued = false; tick(); }, 200);
  }

  if (document.readyState === 'loading')
    document.addEventListener('DOMContentLoaded', tick);
  else tick();
  document.addEventListener('shopify:section:load', queue);
  window.addEventListener('resize', queue);
  if (window.MutationObserver)
    new MutationObserver(queue).observe(document.documentElement, { childList: true, subtree: true });
  setTimeout(tick, 900);
  setTimeout(tick, 2600);
})();

/* ===== MJade — 체크 안 한 것은 결제에서 뺀다 (일본 정본 2026-08-31 이식 · 2026-09-18) =====
 * 서랍에서 체크를 푼 상품을 «실제 결제에서도» 뺀다.
 *
 * ★ 왜 이 방법인가 — 일본이 실제로 재본 결과 그대로:
 *    · /cart/{variant}:{수량} 링크는 결제로 가지만 «장바구니를 덮어쓴다»
 *    · 쇼피파이에는 «장바구니는 그대로 두고 일부만 결제» 가 없다
 *    어느 쪽이든 안 고른 것은 장바구니에서 빠진다. 그러면 무엇을 하는지
 *    분명한 쪽(수량 0 으로 빼고 결제)이 낫다.
 * ★ 줄은 line key 로 가리킨다 — variant id 로 지우면 «같은 상품이 두 줄» 일 때 엉뚱한 줄이 지워진다.
 * ★ 못 뺐으면 결제로 «안 보낸다» — 안 고른 것이 섞여 나가는 게 더 나쁘다.
 * ★ 빼고 나면 쇼피파이가 할인을 «다시 계산» 하므로 결제창 금액이 그때 맞춰진다.
 */
(function () {
  "use strict";
  if (window.__mjChkCheckout) return;
  window.__mjChkCheckout = true;

  var busy = false;

  function rows(){
    var d = document.querySelector('cart-drawer');
    return d ? [].slice.call(d.querySelectorAll('.cart-item')) : [];
  }
  function lineKey(row){
    var q = row.querySelector('[data-key]');
    if (q) return q.getAttribute('data-key');
    var a = row.querySelector('.cart-item__remove');
    var h = a ? (a.getAttribute('href') || '') : '';
    var m = h.match(/[?&]id=([^&]+)/);
    return m ? decodeURIComponent(m[1]) : '';
  }
  function unchecked(){
    var out = [], list = rows();
    for (var i = 0; i < list.length; i++){
      var c = list[i].querySelector('.mjc-chk');
      if (c && !c.checked){
        var k = lineKey(list[i]);
        if (k) out.push(k);
      }
    }
    return { off: out, all: list.length };
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest &&
      e.target.closest('cart-drawer .cart-drawer__footer a[href*="/checkout"],'
                     + ' cart-drawer .cart-drawer__footer .btn--wide');
    if (!btn) return;
    var s = unchecked();
    if (!s.all) return;                  /* 빈 서랍 — 테마에 맡긴다 */
    if (!s.off.length) return;           /* 전부 체크 — 손대지 않는다 */

    e.preventDefault();
    e.stopPropagation();
    if (busy) return;

    if (s.off.length >= s.all){          /* 전부 해제 — 살 것이 없다 */
      var box = document.querySelector('cart-drawer .mjc-chk');
      if (box) { try { box.focus(); } catch (err) {} }
      return;                            /* 알림창은 띄우지 않는다 */
    }

    busy = true;
    var upd = {};
    for (var i = 0; i < s.off.length; i++) upd[s.off[i]] = 0;
    fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: upd })
    }).then(function (r) { return r.json(); })
      .then(function () { window.location.href = '/checkout'; })
      .catch(function () {
        busy = false;
        /* 못 뺐으면 그대로 결제로 보내지 않는다. 서랍에 남아 다시 누를 수 있게 둔다. */
      });
  }, true);
})();
